<template>
  <header class="identity__header ba-relative ba-z-2">
    <div
      class="container ba-flex ba-justify-center xl:ba-pt-12 lg:ba-pb-0 ba-py-6 ba-content-center md:ba-content-start"
    >
      <figure class="identity__logo ba-text-center md:ba-w-84 xl:ba-w-140">
        <img
          src="/img/brand/white/logo.svg"
          class="ba-w-full ba-h-28 ba-inline"
        />
        <!-- <h1
          class="ba-text-xl md:ba-text-3xl ba-text-center"
        >Аналитическая информационная система «Visary»</h1> -->
        <p
          v-if="false"
          class="ba-hidden lg:ba-block ba-text-center ba-max-w-sm ba-mt-5"
        >
          Описание
        </p>
      </figure>
    </div>
  </header>
</template>

<script>
export default {
  name: "vis-login-header"
};
</script>
